import { render, staticRenderFns } from "./FcActivations.vue?vue&type=template&id=74fd5cfa&"
import script from "./FcActivations.vue?vue&type=script&lang=js&"
export * from "./FcActivations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports